import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const addGameFavorite = createAsyncThunk(
  "addGameFavorite/addGameFavorite",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post('/addfavourite', payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const addGameFavoriteSlice = createSlice({
  name: "addGameFavorite",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addGameFavorite.pending, (state) => {
        state.loading = true;
      })
      .addCase(addGameFavorite.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addGameFavorite.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default addGameFavoriteSlice.reducer;
